import { render } from "./DeleteWorkspaceModal.vue?vue&type=template&id=d70f8a2a&scoped=true"
import script from "./DeleteWorkspaceModal.vue?vue&type=script&lang=js"
export * from "./DeleteWorkspaceModal.vue?vue&type=script&lang=js"

import "./DeleteWorkspaceModal.vue?vue&type=style&index=0&id=d70f8a2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d70f8a2a"]])

export default __exports__